// main application hub
import React from "react";

import Appbar from "./appbar";
import Dos from "./dos";
import Intro from "./intro";
import Landing from "./landing";
import Recent from "./recent";
import Interests from "./interests";
import Contact from "./contact";
export default class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <div
          style={{ display: "flex", flexDirection: "column", flexWrap: "wrap" }}
        >
          <Appbar />
          <a name="home">
            <Landing style={{ zIndex: 6 }} />
          </a>
          <a name="intro">
            <Intro />
          </a>
          <a name="services">
            <Dos />
          </a>
          <a name="projects">
            <Recent />
          </a>
          {/*<a name="interests">
            <Interests />
          </a>*/}
          <a name="contact">
            <Contact />
          </a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/main.js